import { joinCn } from '../util';
import createTwStyle from '../util/createTwStyle';
import { DRAWER_SIZE } from './constant';
import type { VDrawerProps } from './type';

const twStyle = createTwStyle<VDrawerProps>();

export default twStyle({
  main: ({ size = DRAWER_SIZE.MD }) => [
    joinCn({
      'w-[1036px]': size === DRAWER_SIZE.MD,
    }),
  ],
});
